import { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { ENV_VARS } from 'ENV_CONFIG';

import { withRouter } from 'react-router';
import JLUiKitStaticContent from 'jl-design-system/utils/content/staticContent';

import { fetchCustomer } from '~/api';
import { staticContent as defaultStaticContent } from './static-content.constants';
import { getDisplayName } from '~/utils';
import { LoadingSpinner } from '../loading-spinner';

import styles from './SidebarLayout.scss';
import { ErrorPage } from '../error-page';

JLUiKitStaticContent.set(defaultStaticContent);

export const withLayout = (Content) =>
  class extends PureComponent {
    static propTypes = {
      dispatchFetchCustomer: PropTypes.func.isRequired,

      location: PropTypes.shape({
        pathname: PropTypes.string.isRequired,
        search: PropTypes.string,
      }).isRequired,

      userInfo: PropTypes.shape({
        firstName: PropTypes.string.isRequired,
        accountCredit: PropTypes.string.isRequired,
      }),

      displaySpinner: PropTypes.bool.isRequired,

      progressBarItems: PropTypes.arrayOf(
        PropTypes.shape({
          pathname: PropTypes.string,
          label: PropTypes.string,
          modalComponent: PropTypes.function,
        }),
      ),
      errorPageStatus: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    };

    static defaultProps = {
      userInfo: null,
      progressBarItems: null,
    };

    static displayName = `WithSidebarLayout(${getDisplayName(Content)})`;

    componentDidMount() {
      const { dispatchFetchCustomer } = this.props;

      dispatchFetchCustomer();
    }

    render() {
      const { displaySpinner, errorPageStatus } = this.props;

      return (
        <>
          <x-jl-mya-header userinfo="true"></x-jl-mya-header>
          <main>
            <div className={styles.container}>
              <div className={styles.columns}>
                <div className={styles.left}>
                  <div className={styles.sidebar}>
                    <x-jl-mya-user></x-jl-mya-user>
                    <x-jl-mya-sidebar-jb
                      active={`${ENV_VARS.REACT_APP_BROWSE_HOST}/appointments/manage`}
                    ></x-jl-mya-sidebar-jb>
                  </div>
                </div>
                <div className={styles.right}>
                  {errorPageStatus ? (
                    <ErrorPage errorType={errorPageStatus} />
                  ) : (
                    <div className={styles.content}>
                      <Content {...this.props} />
                    </div>
                  )}

                  {displaySpinner && (
                    <LoadingSpinner extraClassName={styles.LoadingSpinner} centered size={48} />
                  )}
                </div>
              </div>
            </div>
          </main>
        </>
      );
    }
  };

export const mapStateToProps = ({
  loader: { isCallFinished },
  user: { userInfo },
  errorPage: { status },
}) => ({
  userInfo,
  displaySpinner: !isCallFinished,
  errorPageStatus: status,
});

const mapDispatchToProps = {
  dispatchFetchCustomer: fetchCustomer,
};

const ConnectedWithLayout = (Component) =>
  connect(mapStateToProps, mapDispatchToProps)(withLayout(Component));

export const ConnectedWithSidebarLayoutRouter = (Component) =>
  withRouter(ConnectedWithLayout(Component));
